<mat-card-title>{{'setup'|translate}}</mat-card-title>
<div mat-dialog-content>
    <app-user-profile
        [isSetup]="true"
        [userProfile]="user.profile"
        (saveProfile)="updateProfile($event)"
    ></app-user-profile>
</div>
